import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CapabilityCampaignAssignation, CapabilityResponseDataSchema } from "schema"
import z from "zod"
import { capabilitiesQuery } from "../lib/capabilitiesQuery"
import { marketplaceCapabilitiesQuery } from "../lib/marketplaceCapabilitiesQuery"

type Props = {
  id: string
  campaignAssignation: CapabilityCampaignAssignation
  campaignIds: string[]
  campaignFlow?: "Inbound" | "Outbound"
}

type Response = {
  data: z.infer<typeof CapabilityResponseDataSchema>
}

export function useUpdateCapabilityActivationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...data }: Props) => {
      const response = await axios.patch<Response>(`/capabilities/${id}/activation`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: capabilitiesQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: marketplaceCapabilitiesQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: ["capabilities", "campaign"] })
    },
  })
}
